import { Callout, css, styled } from 'canoe';
import React from 'react';

import { useViewportDom } from 'craft/state';

const CalloutWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spaces.xs};
    background-color: ${theme.colors.OnyxGrayD10};
    color: ${theme.colors.White};
    border-radius: ${theme.borderRadius.small};
    position: relative;
    z-index: 10001;
    width: 300px;
    white-space: initial;
  `}
`;

interface Props {
  children: React.ReactNode;
  isOpen: boolean;
  referenceElement: HTMLButtonElement | null;
  onClose: VoidFunction;
}

export const AskAICallout = ({ children, isOpen, referenceElement, onClose }: Props) => {
  const { viewportWrapperEl } = useViewportDom();

  if (!isOpen) {
    return null;
  }

  return (
    <Callout
      usePortal={false}
      referenceElement={referenceElement}
      onClose={onClose}
      closeKey="Escape"
      placement="bottom"
      modifiers={[
        {
          name: 'preventOverflow',
          options: {
            boundary: viewportWrapperEl,
            padding: 8,
          },
        },
      ]}
    >
      {({ ref, style, attributes }) => (
        <CalloutWrapper data-craft-ignore-events ref={ref} style={style} {...attributes}>
          {children}
        </CalloutWrapper>
      )}
    </Callout>
  );
};
